var React = require('react');

function Arrow2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.4404 9.4404L8.53553 5.53552C6.74659 3.74658 4.45395 2.57714 1.99096 2.16526C0.901515 1.98308 -4.61128e-07 1.10456 -5.0941e-07 -9.53674e-06L32 -1.09355e-05L32 1.51619C32 1.78338 31.7834 1.99728 31.5162 2.00211C28.0172 2.06526 24.6914 3.53649 22.291 6.08308C22.2105 6.16844 22.1283 6.25884 21.964 6.43963L19.3862 9.27512C18.2065 10.5728 17.6167 11.2217 16.9181 11.4746C16.3041 11.697 15.6343 11.713 15.0104 11.52C14.3006 11.3006 13.6805 10.6805 12.4404 9.4404Z","fill":"white"}));
}

Arrow2.defaultProps = {"width":"32","height":"14","viewBox":"0 0 32 14","fill":"none"};

module.exports = Arrow2;

Arrow2.default = Arrow2;
